import {createContext, useContext} from "react";
import Combatant from "@/encounter/model/Combatant.ts";
import {Character} from "@/characters/model/Character.ts";
import type {CombatantTransformBatch} from "@/api/CombatantApi.ts";

export type CombatantUpdatePersistence = "immediate" | "debounced" | "confirmed";

export type CombatantProviderReturn = {
    combatants: Combatant[];
    initialLoading: boolean;
    update: (combatants: Combatant[], persistence?: CombatantUpdatePersistence) => Promise<void>;
    remove: (combatant: Combatant[]) => Promise<void>;
    addCharacter: (character: Character) => Promise<void>;
    longRest: () => Promise<void>;
    previewTransforms: (batch: CombatantTransformBatch) => void;
    commitTransforms: (batch: CombatantTransformBatch) => Promise<void>;
}

export const CombatantContext = createContext<CombatantProviderReturn | null>(null);

export function useCombatants(): CombatantProviderReturn {
    const combatant = useContext(CombatantContext);
    if (!combatant) {
        throw new Error("useCombatants must be used within a Provider")
    }
    return combatant;
}

export const combatantsSort = (a: Combatant, b: Combatant) =>
    a.hostile !== b.hostile ? a.hostile ? 1 : -1 : a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
